import React, { memo, ReactNode, useMemo } from 'react'
import { Button, Modal, Typography } from '@mui/material'
import tw from 'twin.macro'

interface Props {
  isOpen?: boolean
  title?: string
  text?: string
  subtext?: string
  image?: any
  buttons?: ReactNode
  className?: any
  children?: ReactNode
  onClose(): void
}

const CommonModalComponent = ({
  isOpen,
  title,
  text,
  subtext,
  image,
  buttons,
  className,
  children,
  onClose,
}: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur p-4 h-full`}
      disableScrollLock
    >
      <div css={[tw`max-w-[590px] mx-4 flex-col p-4 pt-6 bg-shades-0 rounded-2xl`, className]}>
        {title && (
          <Typography css={tw`mb-2`} variant="h2">
            {title}
          </Typography>
        )}
        {text && <Typography css={tw`mb-6 text-shades-400`}>{text}</Typography>}
        {subtext && <Typography css={tw`mb-6 text-shades-400`}>{subtext}</Typography>}
        {image && <img css={tw`mb-6 w-full max-h-[60vh]`} src={image} />}
        {children}
        {buttons || (
          <Button fullWidth onClick={onClose} variant="contained" css={tw`bg-shades-1000`}>
            <Typography css={tw`text-shades-0`}>Close</Typography>
          </Button>
        )}
      </div>
    </Modal>
  )
}

export const CommonModal = memo(CommonModalComponent)
